const LEFT = 'left';
const RIGHT = 'right';

export { LEFT, RIGHT };
